// Este archivo se genera automáticamente. No editar manualmente.
export const buildInfo = {
  buildNumber: 266,
  lastUpdated: '2026-05-14T11:50:18.041Z',
  version: '1.0.0'
};
